import React from 'react';
// import { v4 as uuidv4 } from 'uuid';
import PageHeading from './components/PageHeading';
import { ChatProvider } from './context/ChatProvider';

import { ChatInput } from './components/ChatInput';
import { ChatMessages } from './components/ChatMessages';

import './tailwindcss_v3.3.2.scss';

export default function ChatbotContainer({
  location, history, onNextStep, isGuestUser,
}) {
  // If more chats are needed we can change this to be a uuid or something
  const chatId = isGuestUser.identityId.split(':').pop();
  // const chatId = uuidv4();
  const { clientId } = location.state.scoringRequest;
  const { requestId } = location.state.scoringRequest;

  return (
    <div className="flex-1 chat-container">
      <main className="flex flex-col w-full chatmain" data-testid="chat-page">
        <section className="flex flex-col flex-1 items-center w-full h-full min-h-[70vh]">
          <PageHeading
            title="Chat with Ginny"
            subtitle="Talk to our agent to help us verify your income"
          />
          <ChatProvider chatId={chatId} clientId={clientId} requestId={requestId}>
            <div className="relative w-full flex flex-col flex-1 items-center">
              <div className="flex-1 w-full flex flex-col items-center">
                <ChatMessages />
              </div>
              <ChatInput location={location} history={history} onNextStep={onNextStep} />
            </div>
          </ChatProvider>
        </section>
      </main>
    </div>
  );
}
